import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {ExportUtil} from '../../../utils/exportUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class APIDataBufferGrid extends BaseComponent {

	constructor() {
		super();
		
		var apiDataBufferGrid = this;
		setTimeout(function(){
			apiDataBufferGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var apiDataBufferGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'download',
					disabled: true,
					theme: 'primary',				
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_API_DATA_BUFFERS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')
					],
					listeners: {
						click: function() {							
							actionDownload(grid.selectedItems[0]);
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'flush',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_API_DATA_BUFFERS:EXECUTE'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Flush')
					],
					listeners: {
						click: function() {							
							actionFlush(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['ADMIN_API_DATA_BUFFERS:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [				
				{						
					path: 'bufferId',
					header: 'Buffer Id',
					width: '5em'						
				},
				{						
					path: 'companyId',
					header: 'Company Id',
					width: '5em'						
				},
				{						
					path: 'companyName',
					header: 'Company Name',
					width: '5em'
				},				
				{						
					path: 'dataTypeDescription',
					header: 'Data Type',
					'text-align': 'center',
					width: '5em'
				},							
				{						
					path: 'flushingStatusDescription',
					header: 'Status',
					'text-align': 'center',
					width: '5em'
				},
				{						
					path: 'recordCount',
					header: 'Records',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'expirationTime',
					header: 'Time Before Expiration',				
					'flex-grow': '1'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'download').disabled = false;
						ElementUtil.query(toolbar, 'flush').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'download').disabled = true;
						ElementUtil.query(toolbar, 'flush').disabled = true; 
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'api-data-buffers',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'api-data-buffers.csv');
			}
		});

		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		apiDataBufferGrid.append(gridLayout);
		
		
		var actionRefresh = function() {
					
			var loadMask = grid.showLoading();
			Service.getApiService().getBuffers().then(function(buffers){						
				grid.activeItem = null;
				grid.items = buffers.data;
				loadMask.remove();
			});
		};
		actionRefresh();
	
		var actionDownload = function(record) {
			Service.getApiService().downloadBuffer(record.bufferId);	
		};
		
		var actionFlush = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Flush',
				message: '<b>Are you sure you want to flush buffer"?</b>',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Processing...');

							Service.getApiService().flushBuffer(record.bufferId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Flushed Buffer: '+ record.bufferId + ' Check Task and Imports for details.', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
				
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete buffer"?</b><br>Records will be discarded.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							Service.getApiService().deleteBuffer(record.bufferId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Buffer: '+ record.bufferId, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};		
		
	}
	
};
customElements.define('dl-api-databuffer-grid', APIDataBufferGrid);



